// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"320":"73cdfd13","7040":"45d737e6"}[chunkId] + ".chunk.css";
};